import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { activeChain, resolve, type ResolvedRoute } from '../routes/helpers';
import { ROUTE_TREE } from '../routes/tree';
import type { RouteNode } from '../routes/types';

/** The resolved tree node for the current URL (undefined off-tree) and the active chain. */
export function useCurrentRoute(): {
  route: ResolvedRoute | undefined;
  chain: readonly RouteNode[];
} {
  const { pathname } = useLocation();
  return useMemo(
    () => ({ route: resolve(ROUTE_TREE, pathname), chain: activeChain(ROUTE_TREE, pathname) }),
    [pathname],
  );
}
